<script lang="ts">
  import { navigate } from '../lib/router.svelte';
  import { requestPasswordReset, ApiError } from '../lib/admin';

  let email = $state('');
  let busy = $state(false);
  let sent = $state(false);
  let error = $state<string | null>(null);

  async function onSubmit(e: SubmitEvent): Promise<void> {
    e.preventDefault();
    if (busy || !email.trim()) return;
    busy = true;
    error = null;
    try {
      await requestPasswordReset(email.trim());
      sent = true;
    } catch (err: unknown) {
      // The server answers 200 even for an unknown address, so a failure here is a real
      // fault (network / server) — show it rather than pretend the mail went out.
      error =
        err instanceof ApiError && err.status === 0
          ? 'Couldn’t reach the server — check your connection and try again.'
          : err instanceof Error
            ? err.message
            : 'Something went wrong. Please try again.';
    } finally {
      busy = false;
    }
  }
</script>

<div class="console-glow flex min-h-screen items-center justify-center px-6">
  <div class="w-full max-w-sm">
    <div class="mb-8 text-center">
      <img src="/icon-128.png" alt="" class="mx-auto mb-4 h-11 w-11 rounded-xl" />
      <div class="eyebrow mb-2">Account recovery</div>
      <h1 class="font-display text-2xl font-bold tracking-tight">Reset your password</h1>
    </div>

    <div class="rounded-box border hair bg-base-200/60 p-6 shadow-2xl shadow-black/40">
      {#if sent}
        <div class="flex flex-col gap-4 text-center">
          <div class="text-3xl">📬</div>
          <p class="text-sm text-base-content/80">
            If an account exists for <span class="font-mono">{email.trim()}</span>, a reset
            link is on its way. It expires in an hour.
          </p>
          <p class="text-xs text-base-content/50">
            Didn’t get it? Check spam, or
            <button class="link link-primary" onclick={() => { sent = false; }}>try another email</button>.
          </p>
          <button class="btn btn-ghost btn-sm mt-1" onclick={() => navigate('/admin/login')}>
            Back to sign in
          </button>
        </div>
      {:else}
        <p class="mb-4 text-sm text-base-content/70">
          Enter your email and we’ll send a link to set a new password.
        </p>
        <form class="flex flex-col gap-4" onsubmit={onSubmit}>
          <label class="block">
            <span class="eyebrow mb-1.5 block">Email</span>
            <input
              type="email"
              class="input input-bordered w-full bg-base-100/60 font-mono text-sm"
              bind:value={email}
              autocomplete="username"
              placeholder="you@example.com"
              required
            />
          </label>

          {#if error}
            <div class="rounded-field border border-error/30 bg-error/10 px-3 py-2 text-sm text-error">
              {error}
            </div>
          {/if}

          <button type="submit" class="btn btn-primary mt-1 gap-2 font-semibold" disabled={busy}>
            {#if busy}<span class="loading loading-spinner loading-sm"></span>{/if}
            Send reset link
          </button>
        </form>
        <div class="mt-4 text-center">
          <button class="eyebrow link" onclick={() => navigate('/admin/login')}>Back to sign in</button>
        </div>
      {/if}
    </div>

    <p class="eyebrow mt-5 text-center">Sideguide · content control</p>
  </div>
</div>
